<script setup>
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <div class="flex flex-col bg-[#ffffff] transition-all ease-in dark:bg-[#000060]">
    <NuxtLoadingIndicator class="z-30" />

    <MoleculeLayoutTheHeader />
    <div class="flex-1">
      <slot />
    </div>
    <LazyMoleculeLayoutSignUpForUpdates v-if="!route?.meta?.excludeComponent?.signUpForUpdates" />
    <MoleculeLayoutTheBanner v-if="!route?.meta?.excludeComponent?.getTheVrHeadset" />
    <AtomPromotionFeatured v-if="!route?.meta?.excludeComponent?.featured" />
    <MoleculeLayoutTheFooter />
    <LazyMoleculeLayoutTheMobileNavigation
      v-if="!route?.meta?.excludeComponent?.mobileNavigation"
    />
    <!-- The is the /program/:id bottom components placeholder -->
    <div id="outer" class="sticky bottom-0 z-[1]" />
  </div>
</template>
